module.exports = __webpack_public_path__ + "img/cow.a4d38190.svg";